<elcia-title [iconType]="'finances'" [title]="'app.finances' | translate"/>
<elcia-tabs [items]="items()"/>
<router-outlet/>
